import { render } from "./ArrowFatLinesUpIcon.vue?vue&type=template&id=4e0dcbd0"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__